import { render, staticRenderFns } from "./RecruitmentComponent.vue?vue&type=template&id=1805cdda&scoped=true&"
import script from "./RecruitmentComponent.vue?vue&type=script&lang=js&"
export * from "./RecruitmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805cdda",
  null
  
)

export default component.exports